import CodiSystem from '../codiSystem/index';

function getPhysicsCoordinate(cubeId: CubeId): PhysicsCoordinate|null {
    return CodiSystem.getPhysicsCoordinate(cubeId);
}

function getLogicCoordinate(cubeId: CubeId): LogicCoordinate|null {
    return CodiSystem.getLogicCoordinate(cubeId);
}

function getPaintCoordinate(cubeId: CubeId): PaintCoordinate {
    return CodiSystem.getPaintCoordinate(cubeId);
}

export {
    getPhysicsCoordinate,
    getLogicCoordinate,
    getPaintCoordinate
};
